import axios from "axios";
import client, { client2 } from "../auth/client";

export const getRefreshedTokens = async (reqBody: { refresh: string }) => {
  const res = await client2.post("/token/refresh/", reqBody);
  return res;
};

export const fetchUserData = async (
  access_token: string,
  is_access_requested?: boolean
) => {
  const response = await client.get(
    `/login/?access_token=${access_token}${
      is_access_requested ? "&is_access_requested=true" : ""
    }`
  );
  return response.data;
};

export const fetchProfileData = async () => {
  const response = await client.get("/auth/get_user_data/");
  return response.data;
};

export const checkGoogleAccessTokenValidity = async (access_token: string) => {
  const url = `https://www.googleapis.com/oauth2/v1/tokeninfo?access_token=${access_token}`;
  const res = await axios.get(url);
  return res.data;
};

export const getTokensFromGAuthCode = async (reqBody: {
  code: string;
  redirect_uri: string;
}) => {
  const res = await client.post(
    "/auth/get_gauth_token_from_auth_code/",
    reqBody
  );
  return res.data;
};

export const getNewAccessAndRefreshTokens = async (reqBody: {
  refresh_token: string;
  redirect_uri: string;
}) => {
  const res = await client.post(
    "/auth/get_gauth_token_from_refresh_token/",
    reqBody
  );
  return res.data;
};
